export const Footer = () => (
  <footer className="border-t border-[#E7E7EC] py-10 bg-white">
    <div className="max-w-[1120px] mx-auto px-6 flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
      <a href="#top" data-testid="footer-logo">
        <img src="/dhwani-logo.png" alt="Dhwani Rural Information Systems" className="h-10 w-auto" />
      </a>
      <p className="text-[13px] text-[#9498A3] max-w-[460px] leading-relaxed">
        Prepared by Dhwani RIS · Based on the DPDP Act 2023 and Rules 2025 · Planning guidance, not legal advice.
      </p>
      <div className="flex items-center gap-5">
        <a href="/Dhwani-DPDP-Approach.pptx" download="Dhwani-DPDP-Approach.pptx" data-testid="footer-download-approach-link" className="text-[13px] font-semibold text-[#9E1B32] hover:text-[#7A1426] transition-colors">
          Download DPDP Approach
        </a>
        <a href="mailto:partnerships@dhwaniris.com" data-testid="footer-email-link" className="text-[13px] font-semibold text-[#9E1B32] hover:text-[#7A1426] transition-colors">
          partnerships@dhwaniris.com
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
